import * as React from 'react'
import { connect } from 'react-redux'
import { BillingPaymentsListComponent } from './BillingPaymentsList'
import { replace } from 'react-router-redux'
import { reduxForm } from 'redux-form'
import { flow } from 'lodash'

const form = 'BillingPaymentsList'

export interface IBillingPaymentsListContainerProps {
  page: number
  ban?: string
}

const stateToProps = ({ billing }, { ban }: IBillingPaymentsListContainerProps) => ({
  banOptions: [
    { name: 'Any', value: '' },
    ...billing.billingAccounts.map(account => ({
      name: `${account.ban} - ${account.name}`,
      value: account.ban,
    })),
  ],
  initialValues: {
    ban,
  },
})

export const dispatchToProps = {
  replace,
}

export const BillingPaymentsList = flow<any, any, React.SFC<IBillingPaymentsListContainerProps>>(
  reduxForm({ form, enableReinitialize: true }),
  connect(stateToProps, dispatchToProps)
)(BillingPaymentsListComponent)



// WEBPACK FOOTER //
// src/features/BillingPayments/BillingPaymentsList/BillingPaymentsList.container.ts